import App from '@/App';
import { ProtectedApp } from '@/components/ProtectedApp';
import { onSigninCallback, userManager } from '@/config/keycloak';
import '@/i18n/config';
import { Layout } from '@/layout/Layout';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import '@/styles/index.css';
import 'react-toastify/dist/ReactToastify.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root is missing from index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter basename="/">
      <AuthProvider userManager={userManager} onSigninCallback={onSigninCallback}>
        <Layout>
          <ProtectedApp>
            <App />
          </ProtectedApp>
          <ToastContainer position="bottom-right" autoClose={6000} newestOnTop={true} draggable={false} />
        </Layout>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
